import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row-line"
}
const _hoisted_2 = { class: "row-content p-field-checkbox" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 1,
  class: "row-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setValue())),
    class: ["list-item-check", { 'listitem-disabled': _ctx.disabled, 'row-style': _ctx.rowStyle }]
  }, [
    (!_ctx.rowStyle)
      ? (_openBlock(), _createBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_Checkbox, {
          disabled: _ctx.disabled,
          inputId: _ctx.inputId,
          name: _ctx.name,
          modelValue: _ctx.modelValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue = $event)),
          value: _ctx.value,
          binary: _ctx.binary
        }, null, 8, ["disabled", "inputId", "name", "modelValue", "value", "binary"]),
        _renderSlot(_ctx.$slots, "checkbox-label", {}, () => [
          _createVNode("label", {
            class: ["ml-2", { 'mr-2': _ctx.rowStyle }],
            for: _ctx.inputId
          }, _toDisplayString(_ctx.label), 11, ["for"])
        ])
      ]),
      _renderSlot(_ctx.$slots, "checkbox-sublabel")
    ]),
    (_ctx.last && !_ctx.rowStyle)
      ? (_openBlock(), _createBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}